const TOKEN_KEY = 'wrenchlog_jwt'
const USER_KEY = 'wrenchlog_user'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token)
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
}

export function getUser() {
  const data = localStorage.getItem(USER_KEY)
  return data ? JSON.parse(data) : null
}

export function setUser(user) {
  localStorage.setItem(USER_KEY, JSON.stringify(user))
}

export function isLoggedIn() {
  return !!getToken()
}

export async function login(email, password) {
  const response = await fetch('/api/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ user: { email, password } }),
  })

  if (!response.ok) {
    const data = await response.json().catch(() => ({}))
    throw new Error(data.error || 'Invalid email or password')
  }

  const token = response.headers.get('Authorization')?.replace('Bearer ', '')
  const data = await response.json()

  if (token) {
    setToken(token)
    setUser(data.user)
  }

  return data.user
}

export async function signup(name, email, password, passwordConfirmation) {
  const response = await fetch('/api/signup', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      user: { name, email, password, password_confirmation: passwordConfirmation },
    }),
  })

  if (!response.ok) {
    const data = await response.json().catch(() => ({}))
    throw new Error(data.errors?.join(', ') || 'Registration failed')
  }

  const data = await response.json()

  if (!data.confirmation_required) {
    const token = response.headers.get('Authorization')?.replace('Bearer ', '')
    if (token) {
      setToken(token)
      setUser(data.user)
    }
  }

  return data
}

export async function logout() {
  const token = getToken()
  if (token) {
    await fetch('/api/logout', {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}` },
    }).catch(() => {})
  }
  clearToken()
}
